import React from "react";
import { motion } from "framer-motion";

export default function Projects() {
  const projects = [
    {
      id: 1,
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
        </svg>
      ),
      title: "Manly Man Co. - E-commerce Platform",
      description: "Premium men's gift e-commerce platform specializing in jerky bouquets, meat gifts, and masculine gift sets. Features custom product bundles, subscription services, and personalized gift messaging for unique masculine gifting experiences.",
      link: "https://manlymanco.com/",
      image: "./project1.webp",
      tags: ["Shopify", "E-commerce", "Gift Platform", "Custom Products"]
    },
    {
      id: 2,
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      ),
      title: "Warroad - Hockey Apparel & Equipment",
      description: "Premium hockey apparel and equipment platform featuring TILO cut-resistant technology for player safety. Specializes in protective gear, training wear, and tech sportswear designed by and for professional hockey players, trusted by NHL stars.",
      link: "https://warroad.com/",
      image: "./66.webp",
      tags: ["Sports", "Hockey", "Safety Equipment", "Athletic Apparel"]
    },
    {
      id: 3,
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      ),
      title: "Fatty15 - Health & Wellness Platform",
      description: "Science-driven wellness platform focused on C15:0 (pentadecanoic acid) supplements for cellular health. Features comprehensive research content, subscription management, and educational resources about essential fatty acids and longevity science.",
      link: "https://fatty15.com/",
      image: "./project2.webp",
      tags: ["Health & Wellness", "Science", "Supplements", "Education"]
    },
    {
      id: 4,
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
        </svg>
      ),
      title: "She's Birdie - Personal Safety Platform",
      description: "Women's personal safety e-commerce platform featuring stylish personal safety alarms and security devices. Offers educational safety content, community features, and subscription options for safety-conscious women and students.",
      link: "https://www.shesbirdie.com/",
      image: "./project4.webp",
      tags: ["Safety", "Women's Products", "E-commerce", "Personal Security"]
    },
    {
      id: 5,
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z" />
        </svg>
      ),
      title: "Voluspa - Luxury Fragrance Platform",
      description: "Luxury candle and home fragrance e-commerce platform featuring artisanal candles, reed diffusers, and fragrance collections. Showcases sophisticated product photography, gift curation tools, and immersive brand storytelling for premium home decor enthusiasts.",
      link: "https://voluspa.com/",
      image: "./project6.webp",
      tags: ["Luxury", "Fragrance", "Home Decor", "Premium E-commerce"]
    },
    {
      id: 6,
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      title: "Size.ca - Fashion E-commerce Platform",
      description: "Canadian fashion retailer offering trendy clothing and accessories with intelligent size recommendation technology. Features comprehensive size guides, wishlist functionality, and seamless checkout optimized for Canadian customers.",
      link: "https://size.ca/",
      image: "./project5.jpg",
      tags: ["Fashion", "E-commerce", "Size Recommendations", "Canadian Retail"]
    }
  ];





  return (
    <div className="space-y-8">
      {/* Header Section */}
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
          Featured Projects
        </h2>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
          Showcasing my expertise in Shopify development and modern web applications
        </p>
      </div>

      {/* Projects Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
        {projects.map((project, index) => (
          <motion.div
            key={project.id}
            className="group relative bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500"
            whileHover={{ 
              y: -8,
              transition: { duration: 0.3, ease: "easeOut" }
            }}
          >
            {/* Project Image */}
            <div className="relative h-48 md:h-56 overflow-hidden bg-gradient-to-br from-purple-50 to-blue-50">
              <motion.img
                src={project.image}
                alt={`${project.title} preview`}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              <motion.div 
                className="absolute inset-0 flex flex-col items-center justify-center text-gray-400 bg-gradient-to-br from-purple-100 to-blue-100" 
                style={{ display: 'none' }}
              >
                <motion.div 
                  className="text-6xl mb-2"
                  initial={{ scale: 0.8 }}
                  animate={{ scale: 1 }}
                  transition={{ duration: 0.5 }}
                >
                  {project.icon}
                </motion.div>
                <div className="text-lg font-medium text-gray-700">{project.title}</div>
                <div className="text-sm mt-1 text-gray-500">Shopify Project</div>
              </motion.div>
              
              {/* Overlay on hover */}
              <motion.div 
                className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                initial={{ opacity: 0 }}
                whileHover={{ opacity: 1 }}
              /> 
              
              {/* View Project Button */}
              <motion.a
                href={project.link}
                target="_blank"
                rel="noopener noreferrer"
                className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm p-2 rounded-full shadow-lg opacity-0 group-hover:opacity-100 transition-all duration-300 hover:bg-white hover:scale-110"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
              >
                <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </motion.a>
            </div>

            {/* Project Content */}
            <div className="p-6">
              <motion.h3 
                className="text-xl font-bold text-gray-900 mb-3"
                whileHover={{ x: 5 }}
                transition={{ duration: 0.2 }}
              >
                {project.title}
              </motion.h3>
              
              <motion.p 
                className="text-gray-600 mb-6 leading-relaxed text-sm"
                initial={{ opacity: 0.8 }}
                whileHover={{ opacity: 1 }}
              >
                {project.description}
              </motion.p>
              
              {/* Bottom Action */}
              <div className="flex items-center justify-between">
                <motion.a
                  href={project.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-sm font-medium text-purple-600 hover:text-purple-700 transition-colors group/link"
                  whileHover={{ x: 3 }}
                  transition={{ duration: 0.2 }}
                >
                  View Project
                  <motion.svg 
                    className="ml-1 w-4 h-4 group-hover/link:translate-x-1 transition-transform duration-200" 
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                  </motion.svg>
                </motion.a>
                
                <div className="text-xs text-gray-400">
                  Shopify Store
                </div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>


    </div>
  );
} 